export enum AlertCountAggreagationType {
    DAY = 'DAY',
    WEEK = 'WEEK',
    MONTH = 'MONTH',
}